import Vue from "vue";
import "babel-polyfill";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.sass";
import i18n from "./i18n";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSocketIO from "vue-socket.io";
import Toasted from "vue-toasted";
import { DatetimePicker } from "vant";

Vue.config.productionTip = false;
Vue.use(DatetimePicker);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDXywVbCLffjc6y3PCdGAKS1DJ-qF-RllE",
    libraries: "places",
    region: "ES",
    language: "es"
    // v: "3.26"
  }
  // Demonstrating how we can customize the name of the components
  // installComponents: false
});

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: process.env.VUE_APP_SOCKET_URL,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    },
    options: { path: "" } //Optional options
  })
);

Vue.use(Toasted, {
  position: "top-center",
  className: "custom-toasted",
  duration: 2000
});

import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";

import GSignInButton from "vue-google-signin-button";
Vue.use(GSignInButton);

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
